<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      d="M1 12C1.00004 5.9249 5.92489 1 12 1C18.0751 1.00004 23 5.92493 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM5.61816 14.7871C4.94826 15.2743 4.80004 16.2119 5.28711 16.8818C5.77432 17.5518 6.71187 17.7 7.38184 17.2129L12 13.8545L16.6182 17.2129C17.2881 17.7 18.2257 17.5518 18.7129 16.8818C19.2 16.2119 19.0517 15.2743 18.3818 14.7871L13.4707 11.2148C12.5941 10.5773 11.4059 10.5773 10.5293 11.2148L5.61816 14.7871ZM5.61816 9.28711C4.94826 9.77431 4.80004 10.7119 5.28711 11.3818C5.77432 12.0518 6.71187 12.2 7.38184 11.7129L12 8.35449L16.6182 11.7129C17.2881 12.2 18.2257 12.0518 18.7129 11.3818C19.2 10.7119 19.0517 9.77431 18.3818 9.28711L13.4707 5.71484C12.5941 5.07733 11.4059 5.07733 10.5293 5.71484L5.61816 9.28711Z"
      fill="currentColor"
    />
  </svg>
</template>
